module.exports = __webpack_public_path__ + "img/yeYaBeng6.033b6813.png";